import { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import diamond from "../Utils/assets/img/diamonds.png"
import { GetRequest, PostRequest } from '../Utils/hooks/ApiHandler'
import useLocalStorageState from 'use-local-storage-state'
import { toast } from 'sonner'
import { IconX } from '@tabler/icons-react'
export const Summary = () => {
    const [customer, setCustomer] = useLocalStorageState("customer")
    const location = useLocation()
    const navigate = useNavigate()
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication
    const data = location?.state || null
    // this will be for both text and border and also i will add a cross button to clear the input
    const [textColor, setTextColor] = useState("")
    const [isCouponValid, setIsCouponValid] = useState("")
    const [isCross, setIsCross] = useState(false)
    const [discountedAmt, setDiscountedAmt] = useState(0)
    const [couponDiscType, setCouponDiscType] = useState(null)
    useEffect(() => {
        if (data === null) {
            navigate("/plans")
            toast.warning("Please select a plan first!")
            return
        }
        return () => { }
    }, [data])
    // API headers configuration
    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }


    const [isCoupon, setCoupon] = useState(false)
    const [couponCode, setCouponCode] = useState("")
    // whenever the coupon is been applied i will make sure to change this total amt value 
    const [totalAmtAfterCoupon, setTotalAmtAfterCoupon] = useState(location?.state !== null && data?.pricing?.duration === "year" ? (Number(data?.totalAmount) * 12) : Number(data?.totalAmount))
    // ----------------------------------------------------------------------

    const payment = async () => {
        try {
            const res = await PostRequest(`plan/payment/${customer.customer_details?.customer_id}`, {}, {}, {})
            if (res.status === "fail" || res.success === false) {
                toast.error(res.message)
                return
            }
            startPayment({ subId: res?.data, appname: res?.app_name, razorkey: res?.key, customer_plan: res?.customer_plan, customer_details: res?.customer_details })
        } catch (error) {
            return
        }
    }
    const verifyMandate = async (data, customer_plan) => {
        try {
            const payload = {
                "customer_id": customer.customer_details?.customer_id,
                customer_plan: customer_plan,
                ...data
            }
            const res = await PostRequest(`plan/verify/`, payload, false, { headers }, extras)
            if (res.status === "fail" || res.success === false) {
                toast.error(res.message)
                return
            }
            toast.success(res.message)
            setCustomer(prev => ({
                ...prev,
                customer_details: {
                    ...prev.customer_details,
                    is_plan: "yes",
                    permission: res.data
                }
            }))
            navigate("/dashboard")

        } catch (error) {
            return
        }
    };

    const startPayment = async ({ subId, appname, razorkey, customer_plan, customer_details }) => {

        const options = {
            key: razorkey,
            amount: totalAmtAfterCoupon,
            currency: "INR",
            subscription_id: subId,
            name: appname,
            description: `${data?.pricing?.duration}ly`.toUpperCase() + " PLAN",
            recurring: true,
            img: "https://dev.pandalms.com/upload/setting/20250923162228_logo_(4).jpeg",
            prefill: {
                name: customer_details?.full_name,
                email: customer_details?.email,
                contact: `+91${customer_details?.phone}`
            },
            handler: function (response) {
                verifyMandate(response, customer_plan);
            },
        };

        // return
        const rzp = new window.Razorpay(options);
        setIsBuy(false)
        rzp.open();
    };


    // ------------------------------------------------------------------------
    const [isBuy, setIsBuy] = useState(false)
   const buyPlan = async () => {
        try {
            setIsBuy(true)
            const payload = {
                customer_id: customer?.customer_details?.customer_id,
                plan_id: data?.planDetails?.id,
                plan_name: data?.selectedPlan,
                plan_amount: data?.pricing?.amount,
                plan_discount: data?.pricing?.discount,
                plan_duration: data?.pricing?.duration,
                coupon_code: couponCode,
                coupon_discount: discountedAmt || 0,
                coupon_discount_type: couponDiscType || null,  //flat / percentage,
                final_amount: totalAmtAfterCoupon
            }
            const res = await PostRequest("plan/buyPlan/", payload, false, { headers }, extras)
            if (res.status === "fail" || res.status === false) {
                setIsBuy(false)
                toast.warning(res.message)
                return
            }
            if (res.status === "free") {
                setCustomer(prev => ({
                    ...prev,
                    customer_details: {
                        ...prev.customer_details,
                        is_plan: "yes",
                        permission: res.permission,
                    }
                }))
                setIsBuy(false)
                navigate("/dashboard")
                toast.success(res.message)
                return
            }
            if (res.status === "success") payment()
 
        } catch (error) {
            return
        }
    }
    // ------------------------------------------------------------------------
    // apply coupon

      const handleApplyCounpon = async (coupon_code, order_amount) => {
        try {
            const res = await GetRequest(`plan/apply_coupon/${coupon_code}/${order_amount}/${customer.customer_details?.customer_id}`, { headers }, extras)
            if (res.status === "fail" || res.successs === false) {
                toast.error(res.message)
                return
            }
            if (res.status === "error") {
                setIsCross(true)
                setTextColor(res.color)
                setIsCouponValid(res.message)
                return
            }
            const discType = res.result[0]?.coupon_type
            const discount = Number(res.result[0]?.discount)
 
            // base amount should match billing amount (monthly or yearly)
            const baseAmount =
                data?.pricing?.duration === "year"
                    ? Number(data?.totalAmount) * 12
                    : Number(data?.totalAmount)
 
            if (discType === "percentage") {
                const totalDisc = (baseAmount * discount) / 100
 
                setCouponDiscType("percentage")
                setDiscountedAmt(totalDisc)
                setTotalAmtAfterCoupon(baseAmount - totalDisc)
            } else {
                const totalDisc = Math.min(discount, baseAmount)
 
                setCouponDiscType("flat")
                setDiscountedAmt(totalDisc)
                setTotalAmtAfterCoupon(baseAmount - totalDisc)
            }
            setIsCross(true)
            setTextColor(res.color)
            setIsCouponValid(res.message)
        } catch (error) {
            return
        }
    }


    return (
        <div style={{ padding: "2rem" }}>
            <div style={{ width: '100%' }}>
                <h1 style={{ letterSpacing: "0.5px" }}>Billing</h1>
            </div>
            {/* main card  */}
            <div style={{ width: "100%", }}>
                <Row className=''>
                    <Col md={8}>
                        <div style={{ width: "100%", height: "auto", padding: "1.5rem", marginTop: "2rem", backgroundColor: "white" }} className='shadow'>
                            <div className='d-flex gap-3 align-items-center justify-content-start'>
                                <img src={diamond} alt="diamond.jpg" style={{ width: "40px", height: "40px" }} />
                                <div className='d-flex flex-column justify-content-start'>
                                    <h3 style={{ paddingTop: '7px', fontSize: '1.3rem', fontWeight: 600, margin: 0 }}>{data?.selectedPlan} Plan</h3>
                                    <p style={{ fontWeight: 500, fontSize: "0.8rem", paddingTop: "3px", textTransform: "capitalize" }}>{data?.planDetails?.description}.</p>
                                </div>
                            </div>

                            <div style={{ borderRadius: "10px", border: "2px solid #0c5cff", width: "fit-content", height: "auto", padding: "8px 12px", backgroundColor: "white", marginTop: "2rem" }} className='shadow'>
                                <div className='d-flex flex-column gap-2'>
                                    <span style={{ fontSize: "1rem", textTransform: "capitalize" }}>{data?.pricing?.duration === "year" ? "Annual" : data?.pricing?.duration}</span>
                                    <span style={{ fontSize: '2rem', textWrap: 'nowrap' }}>{data?.pricing?.duration === "year" ? (Number(data?.totalAmount) * 12)?.toLocaleString() : Number(data?.totalAmount).toLocaleString()}<span style={{ fontSize: "1rem", fontWeight: 600 }}>/ {data?.pricing?.duration}</span></span>
                                </div>
                                {
                                    data?.pricing?.duration === "year" &&
                                    <p style={{ textWrap: 'nowrap', color: "#808080", fontWeight: 500 }}>{data?.totalAmount} / month billed </p>
                                }
                            </div>
                        </div>
                    </Col>

                    <Col md={4}>
                        <div style={{ backgroundColor: "#f7f7f8", width: "100%", height: "auto", padding: "1rem" }}>
                            <h4>Purchase Summary</h4>
                            <hr />
                            <div className='d-flex justify-content-between align-items-start' style={{ width: "100%" }}>
                                {/* <div> */}
                                <p style={{ fontSize: "1rem", fontWeight: 500 }}>{data?.selectedPlan} Plan</p>
                                {/* <span style={{ fontSize: "0.8rem" }}>{planDuration} Year</span> */}
                                {/* </div> */}
                                <span>{data?.pricing?.duration === "year" ? (Number(data?.totalAmount) * 12)?.toLocaleString() : Number(data?.totalAmount)?.toLocaleString()}</span>
                            </div>
                            <hr />
                            <div className='d-flex flex-column gap-2 mb-2'>
                                <p className='' style={{ color: "#0b5cff", cursor: 'pointer', fontSize: "0.8remF" }} onClick={() => setCoupon(!isCoupon)}>{isCoupon ? "Remove" : "Add Coupon Code"}</p>
                                {
                                    isCoupon &&
                                    <div className='d-flex gap-2'>
                                        <div className='d-flex flex-column w-100'>
                                            <div className='position-relative  '>
                                                <input type="text" className='couponText' placeholder='Enter Coupon Code' value={couponCode} onChange={(e) => setCouponCode(e.target.value)} />

                                                <style jsx>{`
                                                   :global(:root) {
                                                        --coupon-color: ${textColor?.trim() === "" ? "black" : textColor};
                                                    };
                                                .couponText {
                                                    color: var(--coupon-color) !important;
                                                }
                                                `}</style>

                                                <style jsx>{`
                                                 
                                                `}</style>
                                                {
                                                    isCross &&
                                                    <IconX
                                                        stroke={2}
                                                        size={18}
                                                        onClick={() => {
                                                            setIsCross(false)
                                                            setCouponCode("")
                                                            setTextColor("")
                                                            setIsCouponValid("")
                                                        }}
                                                        className='position-absolute'
                                                        style={{ right: "1rem", top: '10px', cursor: "pointer", stroke: `${textColor}` }}
                                                    />
                                                }
                                            </div>
                                            {
                                                isCouponValid?.trim() !== "" &&
                                                <p style={{ color: textColor, }} className='fs-14 mt-2'>{isCouponValid}</p>
                                            }
                                        </div>
                                        <button
                                            onClick={() => handleApplyCounpon(couponCode, Number(data?.totalAmount))}
                                            style={{
                                                maxHeight: "2.5rem",
                                                border: 0,
                                                fontSize: '1rem',
                                                padding: "8px 10px",
                                                borderRadius: "8px",
                                                backgroundColor: "#0c5cff",
                                                color: "white",
                                                fontWeight: 600,
                                                cursor: 'pointer',
                                                textWrap: 'nowrap'
                                            }}>
                                            Apply Coupon
                                        </button>
                                    </div>
                                }
                                <div className='d-flex flex-column '>
                                    <div className='d-flex flex-column justify-content-between align-items-start'>
                                        <div className='d-flex align-items-center justify-content-between w-100'>
                                            < p style={{ fontSize: '1rem', fontWeight: 500 }}>Total Amount</p>
                                            {/* <p className='d-flex flex-column gap-2 align-items-end'> */}
                                            <span style={{ fontSize: "1rem", color: "black" }}>{data?.pricing?.duration === "year" ? (Number(data?.totalAmount) * 12).toLocaleString() : Number(data?.totalAmount).toLocaleString()}</span>
                                        </div>
                                        {/* total discounted amount based on the discounted type */}
                                        <div className='d-flex align-items-center justify-content-between w-100'>
                                            <p style={{ fontSize: '0.8rem', fontWeight: 400, }}>Discounted Amount</p>
                                            <span style={{ fontSize: "1rem", color: "black", fontWeight: 400 }}>-{discountedAmt}</span>
                                        </div>
                                    </div>

                                    {/* <p className=' align-self-end'>Inclusive Taxes</p> */}
                                </div>
                            </div>
                            <hr />
                            <div className='d-flex justify-content-between align-items-start mb-1'>
                                <p className='d-flex flex-column gap-1 align-items-start'>
                                    <p style={{ fontSize: '1rem', fontWeight: 500 }}>Total Billed Annually</p>
                                </p>
                                <span style={{ fontSize: "1rem", color: "black" }}>{totalAmtAfterCoupon?.toLocaleString()}</span>
                            </div>
                            <p className='mt-2' style={{ fontSize: "0.8rem" }}>Your purchase may be subject to local taxes based on the billing information you provide. The final charge may be different than the amount shown here and will be displayed on your invoice.</p>
                            <hr />
                            <div className='d-flex justify-content-between align-items-start mb-2'>
                                <span>Today's Total</span>
                                <p className='d-flex flex-column gap-2 align-items-end'>
                                    <span style={{ fontSize: "1rem", color: "black" }}>{totalAmtAfterCoupon?.toLocaleString()}</span>
                                    <span>Inclusive Taxes</span>
                                </p>
                            </div>
                            <button
                                onClick={() => {
                                    buyPlan()
                                }}
                                disabled={isBuy}
                                style={{ border: 0, fontSize: '1rem', padding: "8px 10px", borderRadius: "8px", backgroundColor: "#0c5cff", color: "white", fontWeight: 600, opacity: `${isBuy ? 0.8 : 1}` }} className=' w-100'>
                                {isBuy ? "Redirecting to RazorPay" : "Buy Now"}
                            </button>
                        </div>

                    </Col>
                </Row>
            </div>
        </div >
    )
}
